var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative flex flex-col min-h-screen antialiased"},[_c('Header'),_c('main',{staticClass:"flex flex-1 pageBackgroundColor"},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }